import { render } from "./KioskModeRefreshTimerModal.vue?vue&type=template&id=fdb56af4&scoped=true"
import script from "./KioskModeRefreshTimerModal.vue?vue&type=script&lang=js"
export * from "./KioskModeRefreshTimerModal.vue?vue&type=script&lang=js"

import "./KioskModeRefreshTimerModal.vue?vue&type=style&index=0&id=fdb56af4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdb56af4"]])

export default __exports__